import { useLoginState } from 'state'

import { bootcampsData, BootcampsType } from '../data/bootcampsData'

export const useGenerateApplyNowLink = (type: BootcampsType) => {
  const { user } = useLoginState()
  return user ? bootcampsData[type].isLoggedIn : bootcampsData[type].isLoggedOut
}
